import { render, staticRenderFns } from "./modify-contact.vue?vue&type=template&id=70f5c578"
import script from "./modify-contact.vue?vue&type=script&lang=ts"
export * from "./modify-contact.vue?vue&type=script&lang=ts"
import style0 from "./modify-contact.vue?vue&type=style&index=0&id=70f5c578&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports